module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MCIgaGVpZ2h0PSIzOSIgdmlld0JveD0iMCAwIDUwIDM5Ij4KICAgIDxwYXRoIGZpbGw9IiM5NUM2NEYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTE3LjMyNiAyNy4zMTJMNDQuMTU2LjE4N2w1LjY4OCA1LjYyNi0zMi41MTggMzIuODc1TC4xNTYgMjEuMzNsNS42ODgtNS42MjZ6Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./containers/orderPage/assets/tick-green-big.svg
// module id = hgPZ
// module chunks = 0